import React from 'react';
import { Pagination } from '../../../_lib/components/Pagination';
import { PageListTeaserItem, PageListTeaserPage } from './PageListTeaserItem';
import { Facets } from '../../../types/Facets';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import ResultListSettings from '../../../components/molecules/ResultListSettings/ResultListSettings';
import { FACETS } from '../../../components/molecules/ResultListSettings/ResultListSettings.enums';

type PageListTeaser = {
  items?: any;
  displayOptions?: any;
  sort?: any;
  facets?: Facets;
  pageItems?: any;
  invisibleHeadline?: boolean;
  headline?: string;
  resetAllFiltersUrl?: {
    url: string;
  };
};

/**
 * # PageListTeaser
 *
 * - Component is designed to return page teasers with images, headlines and teaser text.
 * - Additionally, teasers can consist of date, external links and downloads.
 *    They will only be renderd, if they exist in JSON
 * - Modifiers used on ContentHeadline & ContentParagraph to create different font sizes and look.
 * - You can find similar markup and style in the component TopHeadlinesBlock, TopHeadlineItem.
 */
export function PageListTeaser({
  items,
  displayOptions,
  sort = [],
  facets = {},
  pageItems = [],
  invisibleHeadline = true,
  headline,
  resetAllFiltersUrl,
}: PageListTeaser) {
  const { t } = useSonTranslation('PageListDetails');

  const getPages = () => {
    let featuredCounter = 0;
    // @ts-expect-error no typing yet
    return items.reduce((acc, item) => {
      const itemCopy = { ...item };
      if (featuredCounter >= 1) {
        itemCopy.featured = false;
      }

      if (itemCopy.featured) {
        featuredCounter += 1;
      }

      acc.push(itemCopy);

      return acc;
    }, []);
  };

  const showColumn = (columnIdentifier: string) => !displayOptions?.hideColumns?.includes(columnIdentifier);
  const pages = getPages();

  return (
    <div className="page-list-teaser">
      <h2 className={invisibleHeadline ? 'invisible' : 'page-list-teaser__headline'}>
        {headline || t('pageListTeaser.headline')}
      </h2>
      {sort.length !== 0
        ? (
            <ResultListSettings
              sort={sort}
              facets={facets}
              wantedFacets={[FACETS.FQ_ARCHIVEDATE, FACETS.FQ_PAGE_CATEGORY_TITLES]}
              resetAllFiltersUrl={resetAllFiltersUrl}
            />
          )
        : null}
      {pages.length !== 0
        ? (
            <ol className="page-list-teaser__list">
              {pages.map((page: PageListTeaserPage) => (
                <PageListTeaserItem
                  key={page.pageLink.url}
                  page={page}
                  showColumn={showColumn}
                  displayOptions={displayOptions}
                />
              ))}
            </ol>
          )
        : null}
      <Pagination pageItems={pageItems} />
    </div>
  );
}
